<template>
  <b-row>
    <b-nav-item-dropdown
      right
      toggle-class="d-flex align-items-center dropdown-user-link"
      class="dropdown-user"
    >
      <template #button-content>
        <b-row>
          <b-col
            cols="12"
            class="d-flex justify-content-end pr-3"
          >
            <div class="d-sm-flex d-none user-nav">
              <div class="d-flex">
                <div
                  v-for="item in levels"
                  :key="item.product"
                  class="mr-[5px]"
                >
                  <img
                    :id="String(item.product)"
                    class="icon-level"
                    :src="item.level_img_url"
                  >
                  <b-popover
                    :target="String(item.product)"
                    triggers="hover"
                    placement="bottomleft"
                  >
                    <span class="text-black">
                      {{ item.message }}
                    </span>
                  </b-popover>
                </div>
                <h4
                  class="user-name align-items-center d-flex font-weight-bolder mb-0 text-black"
                >
                  {{
                    $store.state.auth.userData.full_name ||
                      $store.state.auth.userData.username
                  }}
                </h4>
              </div>
              <h4 class="user-status align-items-center text-black">
                {{ $store.state.auth.userData.role }}
              </h4>
            </div>
          </b-col>
        </b-row>
        <b-avatar
          size="40"
          :src="$store.state.auth.userData.photo_profile_url"
          variant="light-primary"
          badge
          class="badge-minimal"
          badge-variant="success"
        >
          <feather-icon
            v-if="!$store.state.auth.userData.photo_profile_url"
            icon="UserIcon"
            size="22"
          />
        </b-avatar>
      </template>
      <b-dropdown-item
        link-class="d-flex align-items-center"
        @click="skin = isDark ? 'light' : 'dark'"
      >
        <feather-icon
          size="16"
          :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
          class="mr-50"
        />
        <span>{{ isDark ? 'Light' : 'Dark' }} Mode</span>
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item
        link-class="d-flex align-items-center"
        @click="logout"
      >
        <feather-icon
          size="16"
          icon="LogOutIcon"
          class="mr-50"
        />
        <span>Logout</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>
    <div class="mr-3 ml-50">
      <b-button
        size="sm"
        variant="flat-primary"
        class="btn-icon position-relative"
        @click="showNotification"
      >
        <b-img
          src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/notification-1.svg"
        />
        <div
          v-if="unreadCount > 0"
          class="wrapper-notification-count"
        >
          <span class="text-white font-semibold">{{ unreadCount }}</span>
        </div>
      </b-button>
      <b-modal
        id="modal-notification"
        ref="modal-notification"
        modal-class="myclass"
        hide-footer
        hide-header
        @show="setupNotificationObserver"
      >
        <b-row class="p-1 justify-content-between align-items-center mx-2">
          <div>
            <h4 class="text-black">
              <strong>
                Notifikasi
              </strong>
            </h4>
          </div>
          <div class="d-flex align-items-center">
            <b-button
              size="sm"
              :variant="unreadCount > 0 ? 'flat-primary' : 'flat-secondary'"
              class="ml-2 text-sm font-semibold bg-transparent border-0 shadow-0"
              :disabled="unreadCount === 0"
              @click="readAllNotification"
            >
              Tandai Baca Semua
            </b-button>
            <b-img
              src="https://storage.googleapis.com/komerce/assets/icons/close-circle.svg"
              class="cursor-pointer ml-1"
              @click="$bvModal.hide('modal-notification')"
            />
          </div>
        </b-row>
        <div
          ref="notificationObserver"
          class="wrapper-content-notification"
        >
          <b-row
            v-for="(item, index) in listNotification"
            :key="index + 1"
            spinner-variant="primary"
            :show="loadingNotification && !loadingNextLine"
            :style="
              item.is_read === 0
                ? 'background: #FFECE9; margin-left: -19px; margin-right: -19px; border-top: 1px solid #C2C2C2;'
                : 'background: white; margin-left: -19px; margin-right: -19px; border-top: 1px solid #C2C2C2;'
            "
            class="p-[2rem] cursor-pointer"
            @click="readNotif(item)"
          >
            <b-col cols="2">
              <b-img :src="item.image_path" />
            </b-col>
            <b-col
              cols="10"
              class="d-flex flex-column"
              style="width: 100%;"
            >
              <div
                class="d-flex justify-content-between align-items-center mb-1"
              >
                <span class="text-black font-semibold">
                  {{ item.title }}
                </span>
                <small
                  style="color: #626262;"
                  class="font-semibold"
                >
                  {{ getFormatDate(item.created_at) }}
                </small>
              </div>
              <small
                style="color: #626262;"
                v-html="item.description"
              />
            </b-col>
          </b-row>
          <p
            v-show="loadingNextLine"
            class="flex items-center justify-center gap-[5px] py-2 bg-light-primary rounded"
          >
            <b-spinner
              variant="primary"
              label="loading"
              small
            />Memuat notif
            lainnya...
          </p>
          <div
            ref="lastNotif"
            class="bottom-observer"
            style="height: 10px; width: 100%;"
          />
        </div>
        <div
          class="footer-notification-fixed w-full px-2 flex gap-4 sticky bottom-0 bg-white z-10 py-2"
        >
          <b-button
            variant="outline-primary"
            class="d-flex place-content-center items-center font-semibold !text-sm w-full grow !p-2"
            @click="showAllNotification"
          >
            Tampilkan Semua Pesan
          </b-button>
          <b-button
            :variant="unreadCount === 0 ? 'secondary' : 'primary'"
            class="d-flex w-full place-content-center items-center font-semibold !text-sm grow !p-2"
            :disabled="unreadCount === 0"
            @click="sortNotificationByUnread"
          >
            Pesan Belum Dibaca
            <span
              v-if="unreadCount > 0"
              class="badge badge-pill bg-[#FCD4BE] text-primary ml-1"
            >{{ unreadCount }}</span>
          </b-button>
        </div>
      </b-modal>
      <ModalFormRejected
        id="modal-form-rejected-by-notif"
        :modal="formRejectedModalData"
        @on-confirm="handleFormRejectedRedirect"
        @hidden="formRejectedModalData = {}"
      />
    </div>
  </b-row>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BSpinner,
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import { avatarText } from '@core/utils/filter'
import { mapState } from 'vuex'
import store from '@/store'
import moment from 'moment'
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import { isUserLoggedIn, removeLocalStorageLogout } from '@/auth/utils'
import { newAxiosIns } from '@/libs/axios'
import useJwt from '@/auth/jwt/useJwt'
import ModalFormRejected from '@/views/pages/komads/components/ModalFormRejected.vue'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BSpinner,
    ModalFormRejected,
  },
  data() {
    return {
      avatarText,
      listNotification: [],
      moment,
      level: '',
      icon: '',
      message: '',
      formRejectedModalData: {},
      isTopLevel: false,
      ExpiredWhatsapp: 0,
      user: this.$store.state.auth.userData,
      levels: [],
      unreadCount: 0,
      loadingNotification: false,
      loadingNextLine: false,
      notificationObserver: undefined,
      limits: 10,
      offset: 0,
      lastData: false,
    }
  },
  setup() {
    const { skin } = useAppConfig()
    const isDark = computed(() => skin.value === 'dark')
    return { skin, isDark }
  },
  computed: {
    isAdmin() {
      return isUserLoggedIn() && this.user.role_name?.toUpperCase() === 'ADMIN'
    },
    profileRoute() {
      if (!isUserLoggedIn()) return ''
      if (this.user.role_name?.toUpperCase() === 'SDM') return 'talent-profile'
      if (this.user.role_name?.toUpperCase() === 'PARTNER') return 'partner-profile'
      return ''
    },
    greetingsTime() {
      const date = new Date()
      let dateChange = null
      let str = ''
      if (date.getUTCHours() - date.getHours() !== 0) {
        dateChange = date.getHours()
      } else {
        dateChange = 8 + date.getHours()
      }
      if (dateChange < 4) {
        str = 'Selamat Malam,'
      } else if (dateChange < 11) {
        str = 'Selamat Pagi,'
      } else if (dateChange < 16) {
        str = 'Selamat Siang,'
      } else if (dateChange < 20) {
        str = 'Selamat Sore,'
      } else {
        str = 'Selamat Malam,'
      }
      return str
    },
    ...mapState('dashboard', ['profile', 'levelUser']),
    ...mapState('whatsapp', ['check_wa', 'dashboard_wa']),
  },
  async mounted() {
    const token = useJwt.getToken()
    if (!token) return
    this.getListNotification()
    if (this.levelUser?.length === 0) {
      await this.$store.dispatch('dashboard/getUpdateLevelUser')
    }
    this.levels = this.levelUser
  },
  beforeDestroy() {
    this.notificationObserver.disconnect()
    this.notificationObserver = undefined
  },
  methods: {
    logout() {
      this.logoutAuthModule()
      this.logoutAndRedirectToLoginPage()
    },
    formatPrice(value) {
      let val = 0
      if (value !== undefined) {
        val = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    showNotification() {
      this.$refs['modal-notification'].show()
      this.ExpiredWhatsapp = this.dashboard_wa !== null ? this.dashboard_wa.whatsapp_expired_at : 0
    },
    async getListNotification() {
      this.loadingNotification = true

      const params = {
        limit: this.limits,
        offset: this.offset,
        is_unread: this.unreadNotif,
      }

      const list = newAxiosIns.get('komship/api/v1/notifications/list', {
        params,
      })
      const info = newAxiosIns.get('komship/api/v1/notifications/info')

      const [listData, infoData] = await Promise.all([list, info])
        .catch(() => {
          this.lastData = true
        })
        .finally(() => {
          this.loadingNotification = false
          this.loadingNextLine = false
        })

      if (!listData?.data?.data || listData.data.data.length === 0) {
        this.lastData = true
      } else if (this.listNotification.length > 0) {
        this.listNotification = [
          ...this.listNotification,
          ...listData.data.data,
        ]
      } else {
        this.listNotification = listData.data.data
      }
      this.unreadCount = infoData.data.data.unread_count
    },
    /**
     * Handle notification for marketplace order
     * @param {Object} data - the notification data
     */
    handleMarketplaceOrderNotif(data) {
      const query = {
        status: 'submitted',
      }
      if (data.title === 'Pengajuan Packing Gagal!') {
        query.status = 'submitted'
      }

      this.$router.push({ path: '/marketplace-transaction', query })
      this.$bvModal.hide('modal-notification')
    },
    async readNotif(data) {
      // Optimistic UI: Change is_read status to 1 before API call
      const notifIndex = this.listNotification.findIndex(
        item => item.id === data.id,
      )
      if (
        notifIndex !== -1
        && this.listNotification[notifIndex].is_read === 0
      ) {
        this.listNotification[notifIndex].is_read = 1
        this.unreadCount = Math.max(0, this.unreadCount - 1)
      }
      await this.$http_komship.post(`/v1/notification/read/${data.id}`).catch(() => {
        // Rollback ui
        if (notifIndex !== -1) {
          this.listNotification[notifIndex].is_read = 0
          this.unreadCount += 1
        }
      })

      if (data.notification_type === 'MarketplaceOrder') {
        this.handleMarketplaceOrderNotif(data)
        return
      }

      if (data.notification_type === 'withdrawal') {
        this.$refs['modal-notification'].hide()
        // this.$router.push({ path: `/keuangan/saldo/rincian/${data.reference_id}` }).catch(() => {})
        window.location.assign(`/keuangan/saldo/rincian/${data.reference_id}`)
      } else if (data.notification_type === 'WhatsappPremium') {
        this.$refs['modal-notification'].hide()
        if (
          this.ExpiredWhatsapp > 0
          && this.$route.name !== 'dashboard-whatsapp'
        ) {
          this.$router.push({
            name: 'dashboard-whatsapp',
            params: { modal: 'renew' },
          })
        } else if (
          this.ExpiredWhatsapp > 0
          && this.$route.name === 'dashboard-whatsapp'
        ) {
          this.$bvModal.show('modal-renew-subcription')
        } else if (
          this.ExpiredWhatsapp === 0
          && this.$route.name !== 'opsional-feature'
        ) {
          this.$router.push({
            name: 'opsional-feature',
            params: { modal: 'renew' },
          })
        } else if (
          this.ExpiredWhatsapp === 0
          && this.$route.name === 'opsional-feature'
        ) {
          this.$bvModal.show('modal-choose-wa')
        }
      } else if (data.notification_type === 'InvoiceKomtim') {
        this.$router.push(`/invoice/${data.reference_id}`)
        this.$bvModal.hide('modal-notification')
      } else if (data.notification_type === 'verificationKTPRejected') {
        this.$router.push('/verification-ktp')
        this.$bvModal.hide('modal-notification')
      } else if (data.notification_type === 'verificationKTPApproved') {
        // doing nothing
      } else if (data.notification_type === 'SubmissionKompack') {
        this.$router.push(`/riwayat-pengajuan/produk/${data.reference_id}`)
        this.$bvModal.hide('modal-notification')
      } else if (data.notification_type === 'OutboundKompack') {
        this.$router.push('/history-pickup')
        this.$bvModal.hide('modal-notification')
      } else if (
        data.notification_type === 'komcardTransactions'
        || data.notification_type === 'komcardNotifications'
      ) {
        this.$router.push('/komcards')
        this.$bvModal.hide('modal-notification')
      } else if (data.notification_type === 'komadsNotifications') {
        const { reference_id } = data
        const {
          platform, adAccountType, status, whitelist_account_request_id,
        } = this.translateKomadsReferenceId(reference_id)

        if (['00', '99'].includes(status)) return // On Review or Unknown
        if (['01', '02'].includes(status)) { // On Process CPAS or Accepted
          this.handleKomadsSuccessStatus({ platform, adAccountType, whitelist_account_request_id })
        } else if (status === '03') { // Rejected
          this.handleKomadsRejectedStatus(whitelist_account_request_id)
        }

        this.$bvModal.hide('modal-notification')
      } else {
        this.$refs['modal-notification'].hide()
        window.location.assign(`/ticketing/detail/${data.reference_id}`)
      }
    },
    async readAllNotification() {
      // Save the original copy for rollback
      const originalNotifications = [...this.listNotification]

      // Optimistic update
      this.listNotification = this.listNotification.map(notif => ({
        ...notif,
        is_read: 1,
      }))
      this.unreadCount = 0

      try {
        await newAxiosIns.post('komship/api/v1/notifications/mark-as-read')
      } catch (error) {
        this.listNotification = originalNotifications
        this.unreadCount = originalNotifications.filter(
          notif => notif.is_read === 0,
        ).length
        this.$toast_error({
          message: 'Gagal membaca semua notifikasi',
        })
      }
    },
    sortNotificationByUnread() {
      this.offset = 0
      this.unreadNotif = true
      this.listNotification = []
      this.lastData = false
      this.getListNotification()
    },
    showAllNotification() {
      this.offset = 0
      this.unreadNotif = false
      this.listNotification = []
      this.lastData = false
      this.getListNotification()
    },
    setupNotificationObserver() {
      this.$nextTick(() => {
        if (this.$refs.lastNotif) {
          this.notificationObserver = new IntersectionObserver(
            entries => {
              if (entries[0].isIntersecting) {
                this.handleIntersection()
              }
            },
            {
              root: this.$refs.notificationObserver,
              rootMargin: '0px',
              threshold: 0.1,
            },
          )
          this.notificationObserver.observe(this.$refs.lastNotif)
        } else {
          setTimeout(() => {
            if (this.$refs.lastNotif) {
              this.setupNotificationObserver()
            }
          }, 100)
        }
      })
    },
    handleIntersection() {
      if (!this.loadingNextLine && !this.lastData) {
        this.loadingNextLine = true
        this.offset += this.limits
        setTimeout(() => {
          this.getListNotification()
        }, 1500)
      }
    },
    translateKomadsReferenceId(value) {
      if (!value) return []

      const str = String(value)
      const firstFour = str.slice(0, 4)
      const whitelist_account_request_id = str.slice(4)

      const status = firstFour.slice(-2)
      const [platform, adAccountType] = firstFour.slice(0, -2).split('')

      return {
        platform, // 1 = Meta, 2 = Google, 3 = TikTok, 9 = Unknown
        adAccountType, // 1 = CPAS, 2 = Whitelist, 0 = Unknown
        status, // 00 = On Review, 01 = On Process CPAS, 02 = Accepted, 03 = Rejected, 99 = Unknown
        whitelist_account_request_id,
      }
    },
    handleKomadsSuccessStatus({ platform, adAccountType, whitelist_account_request_id }) {
      const PLATFORM_MAP = {
        1: 'meta',
        2: 'google',
        3: 'tiktok',
        9: '',
      }
      const url = '/whitelisted-account'
      const params = new URLSearchParams()

      const mappedPlatform = PLATFORM_MAP[platform]
      if (mappedPlatform) {
        params.set('platform', mappedPlatform)
      }
      if (platform === '1' && adAccountType === '1') {
        params.set('ad_account_type', 'cpas')
        params.set('wlid', whitelist_account_request_id)
      }

      const query = params.size ? `?${params.toString()}` : ''
      window.location.assign(url + query)
    },
    async handleKomadsRejectedStatus(whitelist_account_request_id) {
      try {
        const { data: { data } } = await newAxiosIns.get(`/komads/api/v1/whitelist_accounts/request/${whitelist_account_request_id}/detail`)
        this.formRejectedModalData = {
          description: data.notes,
          platform: data.platform_name,
          account_request_id: whitelist_account_request_id,
          ad_account_type: data.ad_account_type,
          has_partner_cpas_proof_url: data.partner_cpas_proof_url,
          claim_tier: data.gamification_claim?.claim_tier,
          claim_amount: data.gamification_claim?.spending_threshold,
        }
        this.$bvModal.show('modal-form-rejected-by-notif')
      } catch (error) {
        console.warn(error)
      }
    },
    handleFormRejectedRedirect() {
      const {
        platform, account_request_id, ad_account_type, has_partner_cpas_proof_url, claim_tier, claim_amount,
      } = this.formRejectedModalData

      const postMessage = {
        platform,
        account_request_id,
        ad_account_type,
        status: 'rejected',
        has_partner_cpas_proof_url,
        claim_tier,
        claim_amount,
      }

      this.$store.dispatch('komads/setWhitelistedPostMessage', postMessage)
      this.$bvModal.hide('modal-form-rejected-by-notif')
      window.location.assign('/whitelisted-account')
    },
    getFormatDate(value) {
      const pastDate = moment(value)
      const currentDate = moment(new Date())
      const asHours = moment.duration(currentDate.diff(pastDate))
      const hour = Math.round(asHours.asHours())
      const minutes = Math.round(asHours.asMinutes())
      let format = ''
      if (hour === 0) {
        format = `${minutes} menit yang lalu`
      }
      if (hour === 1 || hour > 1) {
        format = `${hour} jam yang lalu`
      }
      if (hour > 3 && hour < 24) {
        format = moment(new Date(value)).format('HH.mm')
      }
      if (hour >= 20 && hour <= 48) {
        format = `Kemarin ${moment(new Date(value)).format('HH.mm')}`
      }
      if (hour > 48) {
        format = `${moment(new Date(value)).format('DD MMMM YYYY HH.mm')}`
      }
      return format
    },
    logoutAndRedirectToLoginPage() {
      store.commit('dashboard/UPDATE_ِِMY_PROFILE', [])

      this.$store.commit('komcards/UPDATE_VIEW_LIST', 'grid')

      removeLocalStorageLogout()

      // Reset ability
      this.$ability.update(initialAbility)
      // Redirect to login page
      this.$router.push({ name: 'auth-login' })
    },
    logoutAuthModule() {
      const iframe = document.createElement('iframe')
      iframe.src = `${process.env.VUE_APP_BASE_AUTH_MODULE}/logout`
      iframe.width = '0'
      iframe.height = '0'
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
    },
  },
}
</script>
<style scoped>
::v-deep .myclass > .modal-dialog {
  position: unset;
  transform: none !important;
}
::v-deep .myclass > .modal-dialog > .modal-content {
  position: absolute;
  top: 0;
  right: 0;
  width: 500px;
  margin: 7rem 2rem;
}
::v-deep .myclass > .modal-dialog > .modal-content .modal-body {
  padding: 0px !important;
}
.wrapper-content-notification {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 500px;
}
.wrapper-notification-count {
  background: #f95031;
  height: 24px;
  min-width: 28px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -5px;
  right: -5px;
}
.icon-level {
  width: 32px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.footer-notification-fixed {
  width: 100%;
  left: 0;
}
.badge-pill {
  font-size: 12px;
}
</style>
